import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import moment from "moment";
import { removeToCart, clearToCart } from "../../redux/actions/actions";
import { checkAvailabilityCheckoutData } from "../axios";
import Modal from "react-modal";
import { constant, displayDateFormat } from "../AdminPackageDetails/PackageShowcase/commonFunction";

function CartDropDown(props) {
  let subtitle;
  const [DisablePayNowButton, setDisablePayNowButton] = useState(false);
  const [openModal, setopenModal] = useState(false);
  const [reduxData, setreduxData] = useState(null);
  const [checkAvailData, setcheckAvailData] = useState(null);

  const isPackageCart = props.showcart.some(x => x.hasOwnProperty("package_id"));
  const { packageBasicDetails, customerPackageAfterDiscountAmount } = useSelector((state) => state.adminPackageCart);

  const dispatch = useDispatch();

  let closeModal = () => {
    setopenModal(false);
  };
  let ConfirmBooking = (e) => {
    e.preventDefault();
    // setopenModal(true);
    const reduxselectedData = props.showcart;

    checkAvailabilityCheckoutData(reduxselectedData).then(
      (data) => {

        let checkDataAvail = '';
        data.map((checkDataNew, indexJax) => {
          if ((checkDataNew.expreience && (checkDataNew?.expreience[0]["options"][0]["timing"] == "unavailable")) || (checkDataNew.accomodation && (checkDataNew?.accomodation.toString() === "notavil"))) {
            checkDataAvail = 'NoAvaillable';
          }
        });
        if (checkDataAvail == 'NoAvaillable') {
          setopenModal(true);
        } else {
          setTimeout(() => {
            const url = "/paymentcart";
            window.location.replace(url);
          }, 1000);
        }
        setcheckAvailData(data);
      },
      (error) => { }
    );
    setreduxData(props.showcart);
  };
  let ContinuePayment = (e) => {
    checkAvailData != null &&
      checkAvailData.length > 0 &&
      checkAvailData.map((checkData, indexJax) => {
        if (
          checkData.expreience &&
          checkData.expreience[0]["options"][0]["timing"] == "unavailable"
        ) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                // if (i[1].profileactivity != 'Accommodations') {

                // }
                dispatch(removeToCart(indexJ));
              }
            })
          );
        } else if (checkData.accomodation && (checkData.accomodation.toString() == "notavil")) {
          return (
            reduxData != null &&
            reduxData.length > 0 &&
            Object.entries(reduxData).map((i, indexJ) => {
              if (indexJax === indexJ) {
                //  if (i[1].profileactivity != 'Accommodations') {
                //  }
                dispatch(removeToCart(indexJ));
              }
            })
          );
        }
      });

    setTimeout(() => {
      const url = "/paymentcart";
      window.location.replace(url);
    }, 1000);
  };
  const handleRemove = (index) => {
    dispatch(removeToCart(index));
  };

  const handleClear = () => {
    dispatch(clearToCart());
  };

  const getTotalNumber = (item) => {
    if (item.profileactivity != "Accommodations") {
      //console.log(item?.numberTraveler);
      const GuesttravellerCount = JSON.parse(item?.numberTraveler);
      return (
        <>
          {item.price_type == 1 ? (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.adultCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Adults,&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.childCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Children&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.infantCounter * 1,
                0
              ) > 0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.infantCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Infant,&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce((a, v) => a + v.youthCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.youthCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Youth,&nbsp;
                  </>
                )}

              {GuesttravellerCount.reduce(
                (a, v) => a + v.seniorCounter * 1,
                0
              ) > 0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.seniorCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Senior,&nbsp;
                  </>
                )}
            </>
          ) : (
            <>
              {GuesttravellerCount.reduce((a, v) => a + v.groupCounter * 1, 0) >
                0 && (
                  <>
                    <span class="latoBlack">
                      {GuesttravellerCount.reduce(
                        (a, v) => a + v.groupCounter * 1,
                        0
                      )}
                    </span>
                    &nbsp;Travelers,&nbsp;
                  </>
                )}
            </>
          )}
        </>
      );
    } else {
      if (item.typedata == "multiple") {
        const GuesttravellerCount = item.cartvalue;
        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Adults,&nbsp;
                </>
              )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Childs,&nbsp;
                </>
              )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.roomCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Room,&nbsp;
                </>
              )}
          </>
        );
      } else {
        const GuesttravellerCount = item.guestCombination;

        return (
          <>
            {GuesttravellerCount.reduce((a, v) => a + v.adultCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.adultCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Adults,&nbsp;
                </>
              )}
            {GuesttravellerCount.reduce((a, v) => a + v.childCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.childCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Childs,&nbsp;
                </>
              )}

            {GuesttravellerCount.reduce((a, v) => a + v.roomCounter * 1, 0) >
              0 && (
                <>
                  <span class="latoBlack">
                    {GuesttravellerCount.reduce(
                      (a, v) => a + v.roomCounter * 1,
                      0
                    )}
                  </span>
                  &nbsp;Room,&nbsp;
                </>
              )}
          </>
        );
      }
    }
  };
  const totalAmount = props.showcart.reduce(
    (amount, item) => parseFloat(item.price) + amount,
    0
  );
  const finalTotalAmount = totalAmount.toFixed(2);
  return (
    <>
      <div
        className="userDropdown fadeInDown hs-LoginFlex column dropbanner"
      >
        <div
          className="cart-dropdown-preview-inner position-relative bg-white mb-0"
          style={{ padding: "0px", height: "auto" }}
        >
          {props.showcart.length > 0 ? (
            <>
              <div
                className="cart-dropdown-container text-left mb-0 pb-0"
                data-loaded="false"
                style={{}}
              >
                <div class="containerdropdown">
                  <div
                    class="rowdropdown"
                    style={{
                      marginBottom: "0px",
                      background: "#f1f1f1",
                      display: "block",
                      lineHeight: "25px",
                      padding: "10px",
                      fontSize: "17px",
                      fontWeight: "700"
                    }}
                  >Your Cart
                    <span
                      class="col-sm"
                      style={{
                        float: "right",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "#000",
                      }}
                      onClick={() => handleClear()}
                      data-action-capture="click"
                    >
                      Clear All
                    </span>
                  </div>
                </div>
                <div
                  className="cart-preview-container"
                  style={{ padding: "10px" }}
                >
                  <div
                    className="cart-preview-list-container"
                    style={{ overflow: "auto", height: "400px" }}
                  >
                    {isPackageCart &&
                      <div className="media mb-0">
                        <div className="cart-preview-thumbnail-container">
                          <img
                            src={packageBasicDetails?.package_image}
                            className="cart-preview-img"
                          />
                        </div>
                        <div className="media-body ml-3 pt-0 mt-0">
                          <div
                            className="row product-title appendTop10">
                            <div className="col-11 pr-1 appendBottom10">
                              <p
                                id="productName0"
                                className="view-product-cart-details font16"
                                style={{
                                  fontWeight: "700",
                                }}
                              >
                                {packageBasicDetails?.package_name}
                              </p>
                            </div>
                            <div className="col-1 pr-2 pl-1">
                              <div className="edit-close">
                                <button
                                  id="removeCartItem0"
                                  className="remove-cart-item btn btn-link btn-hover-darken pl-2 py-1 pr-0"
                                  type="button"
                                >
                                  <div className="sr-only">
                                    <FontAwesomeIcon
                                      icon={faTrash}
                                      style={{
                                        fontSize: "14px",
                                        marginRight: "5px",
                                      }}
                                    ></FontAwesomeIcon>
                                  </div>
                                </button>
                              </div>
                            </div>
                            <div className="small text-left col-12 body-text">
                              <p
                                class="font14 appendBottom10"
                                style={{ display: "flex" }}
                              >
                                Date:{" "}
                                <span class="latoBlack">
                                  {displayDateFormat(packageBasicDetails?.package_start_date)} - {displayDateFormat(packageBasicDetails?.package_end_date)}
                                </span>
                              </p>
                            </div>

                            <div
                              className="col-12 small body-text appendBottom10 font14">
                              {packageBasicDetails?.package_guestCombination_sentence}
                            </div>
                            <div
                              className="col-lg-12 text-left small price-text appendBottom10">
                              <span
                                className="h4 price-font font16"
                                id="retailPrice0"
                                style={{
                                  fontWeight: 600,
                                }}
                              >
                                {constant.amountWithCurrency(customerPackageAfterDiscountAmount)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="cart-preview-thumbnail-container">
                          <FontAwesomeIcon
                            icon={faTrash}
                            style={{
                              fontSize: "14px",
                              marginRight: "5px",
                              cursor: "pointer",
                              color: "#a8a8a8",
                              marginTop: "10px"
                            }}
                            onClick={() => {
                              const packageIndexes = props.showcart
                                .map((x, index) => (x.hasOwnProperty("package_id") ? index : null))
                                .filter((index) => index !== null);
                              packageIndexes.reverse().forEach((index) => handleRemove(index));
                            }}
                          ></FontAwesomeIcon>
                        </div>
                      </div>
                    }
                    {props.showcart.length > 0 &&
                      Object.entries(props.showcart).map((i, j) => {
                        if (i[1].profileactivity != "Accommodations") {
                          return (
                            <>
                              <div className={`media mb-0${i[1].hasOwnProperty("package_id") ? " d-none" : ""}`}>
                                <div className="cart-preview-thumbnail-container">
                                  <img
                                    src={i[1].tourImage}
                                    className="cart-preview-img"
                                  />
                                </div>
                                <div className="media-body ml-3 pt-0 mt-0">
                                  <div
                                    className="row product-title appendTop10">
                                    <div className="col-11 pr-1 appendBottom10">
                                      <p
                                        id="productName0"
                                        className="view-product-cart-details font16"
                                        style={{
                                          fontWeight: "700",
                                        }}
                                      >
                                        {i[1].tourName}
                                      </p>
                                    </div>
                                    <div className="col-1 pr-2 pl-1">
                                      <div className="edit-close">
                                        <button
                                          id="removeCartItem0"
                                          className="remove-cart-item btn btn-link btn-hover-darken pl-2 py-1 pr-0"
                                          type="button"
                                        >
                                          <div className="sr-only">
                                            <FontAwesomeIcon
                                              icon={faTrash}
                                              style={{
                                                fontSize: "14px",
                                                marginRight: "5px",
                                              }}
                                            ></FontAwesomeIcon>
                                          </div>
                                        </button>
                                      </div>
                                    </div>
                                    <div className="small text-left col-12 body-text">
                                      <p
                                        class="font14 appendBottom10"
                                        style={{
                                          display: "flex",
                                        }}
                                      >
                                        {" "}
                                        Date:{" "}
                                        <span class="latoBlack">
                                          {moment(i[1].dateselected).format(
                                            "D MMM Y"
                                          )}{" "}
                                          (
                                          {i[1].time == "" ? (
                                            <> Coordinated Times</>
                                          ) : (
                                            <>{i[1].time}</>
                                          )}
                                          )
                                        </span>{" "}
                                      </p>
                                    </div>

                                    <div
                                      className="col-12 small body-text appendBottom10 font14">
                                      {getTotalNumber(i[1])}
                                    </div>
                                    <div
                                      className="col-lg-12 text-left small price-text appendBottom10">
                                      <span
                                        className="h4 price-font font16"
                                        id="retailPrice0"
                                        style={{
                                          fontWeight: 600,
                                        }}
                                      >
                                        <span>€</span>{" "}
                                        {parseFloat(i[1].price).toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="cart-preview-thumbnail-container">
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    style={{
                                      fontSize: "14px",
                                      marginRight: "5px",
                                      cursor: "pointer",
                                      color: "#a8a8a8",
                                      marginTop: "10px"
                                    }}
                                    onClick={() => handleRemove(j)}
                                  ></FontAwesomeIcon>
                                </div>
                              </div>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <div className={`media mb-0${i[1].hasOwnProperty("package_id") ? " d-none" : ""}`}>
                                <div className="cart-preview-thumbnail-container">
                                  <img
                                    src={i[1].hotelimage}
                                    className="cart-preview-img"
                                  />
                                </div>
                                <div className="media-body ml-3 pt-0 mt-0">
                                  <div
                                    className="row product-title appendTop10">
                                    <div className="col-11 pr-1 appendBottom10">
                                      <p
                                        id="productName0"
                                        className="view-product-cart-details font16"
                                        style={{
                                          fontWeight: "700",
                                        }}
                                      >
                                        {i[1].propertyName}
                                      </p>
                                    </div>
                                    <div className="col-1 pr-2 pl-1">
                                      <div className="edit-close">
                                        <button
                                          id="removeCartItem0"
                                          className="remove-cart-item btn btn-link btn-hover-darken pl-2 py-1 pr-0"
                                          type="button"
                                        >
                                          <div className="sr-only">
                                            <FontAwesomeIcon
                                              icon={faTrash}
                                              style={{
                                                fontSize: "14px",
                                                marginRight: "5px",
                                              }}
                                            ></FontAwesomeIcon>
                                          </div>
                                        </button>
                                      </div>
                                    </div>
                                    <div className="small text-left col-12 body-text">
                                      <p
                                        class="font14 appendBottom10"
                                        style={{ display: "flex" }}
                                      >
                                        Check-In:{" "}
                                        <span class="latoBlack">
                                          {moment(i[1].startDate).format(
                                            "D MMM Y"
                                          )}{" "}
                                          ({i[1].checkin})
                                        </span>{" "}
                                      </p>
                                      <p
                                        class="font14 appendBottom10"
                                        style={{
                                          display: "flex",
                                        }}
                                      >
                                        Check-Out:{" "}
                                        <span class="latoBlack">
                                          {moment(i[1].endDate).format(
                                            "D MMM Y"
                                          )}{" "}
                                          ({i[1].checkout})
                                        </span>
                                      </p>
                                    </div>
                                    <div
                                      className="col-12 small body-text appendBottom10 font14">
                                      {i[1].profileactivity == "Accommodations" &&
                                        getTotalNumber(i[1])}
                                    </div>
                                    <div
                                      className="col-lg-12 text-left small price-text appendBottom10">
                                      <span
                                        className="h4 price-font font16"
                                        id="retailPrice0"
                                        style={{
                                          fontWeight: 600,
                                        }}
                                      >
                                        <span>€</span>{" "}
                                        {parseFloat(i[1].price).toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="cart-preview-thumbnail-container">
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    style={{
                                      fontSize: "14px",
                                      marginRight: "5px",
                                      cursor: "pointer",
                                      color: "#a8a8a8",
                                      marginTop: "10px"
                                    }}
                                    onClick={() => handleRemove(j)}
                                  ></FontAwesomeIcon>
                                </div>
                              </div>
                            </>
                          );
                        }
                      })}
                  </div>
                  <div
                    className="row border-top mb-0 pt-3 pb-3"
                    style={{ marginLeft: "10px" }}
                  >
                    <div className="col-6 cart-total-item ml-2">
                      Cart Total (
                      <span id="addItemCartTotal" data-total="1">
                        {props.showcart.length} item
                      </span>
                      )
                    </div>
                    <div className="col-5 pt-0 pr-0 mr-0 text-right">
                      <div
                        id="addItemTotalPrice"
                        className="font-weight-bold price-font"
                      >
                        <span>€</span> {finalTotalAmount}{" "}
                      </div>
                    </div>
                  </div>
                  <div
                    className="row pb-3"
                    style={{ marginLeft: 0, marginRight: 0 }}
                  >
                    <div className="col-6 text-right">
                      {" "}
                      <NavLink
                        to="/cartview"
                        className="primaryBtn2 appendBottom15"
                        data-action-capture="click" style={{ padding: 10 }}
                      >
                        View Cart ({props.showcart.length})
                      </NavLink>
                    </div>
                    {/* <div className="col-6 text-left">
                <button  onClick={ConfirmBooking}
                      className="primaryBtn2 btn-block go-to-checkout-button" data-action-capture="click" data-action-tag="cart_preview_checkout">Checkout</button>
              </div> */}
                    <div className="col-6 text-left">
                      <a
                        href="/home"
                        className="primaryBtn2 appendBottom15"
                        data-action-capture="click" style={{ padding: 10 }}
                      >
                        Continue Booking
                      </a>
                    </div>
                  </div>
                  <div id="cart-preview-gtm-container"></div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                className="cart-dropdown-container text-left mb-0 pb-0"
                data-loaded="false"
                style={{ height: '85px' }}
              >
                <div className="cart-preview-container"></div>
                <div className="row mb-0 pt-3 pb-3">
                  <p style={{ fontSize: '15px', textAlign: 'center', fontWeight: 700, fontFamily: 'sans-serif' }}>
                    Your cart is empty
                  </p>
                  <img
                    src="./images/cart/cart.gif"
                    alt=""
                    className="emptycart_img"
                    style={{ width: "4rem", margin: "auto" }}
                  />
                </div>
              </div>
            </>
          )}
        </div>


      </div>
      <Modal
        className="Modal"
        ariaHideApp={false}
        overlayClassName="backdrop"
        isOpen={openModal}
        onRequestClose={closeModal}
      >
        <div className="modalCont">
          <span className="closeButton" onClick={closeModal}>
            Close
          </span>
          {checkAvailData != null &&
            checkAvailData.length > 0 &&
            checkAvailData.map((checkData, indexJax) => {
              if ((checkData.expreience &&
                checkData.expreience[0]["options"][0]["timing"] ==
                "unavailable") ||
                checkData.accomodation && (checkData.accomodation == "notavil")) {
                <h4>No Cart Availability :</h4>;
              }
            })}
          <div className="modalContent">
            <div>
              <div className="latoRegular font16 appendBottom15">
                <b>
                  The availability changes rapidly. Your following bookings
                  availability has been changed.
                </b>
              </div>
            </div>
            <div>
              <table class="table table-striped">
                <thead>
                  {checkAvailData != null &&
                    checkAvailData.length > 0 &&
                    checkAvailData.map((checkData, indexJax) => {
                      if ((checkData.expreience && (checkData.expreience[0]["options"][0]["timing"] == "unavailable")) || (checkData.accomodation && (checkData.accomodation.toString() == "notavil"))) {
                        return (<tr>
                          <th scope="col">Option</th>
                          <th scope="col">Booking Item </th>
                          <th scope="col">Requested Availability </th>
                          <th scope="col">Current Availability </th>
                        </tr>);
                      }
                    })}
                </thead>
                <tbody>
                  {checkAvailData != null &&
                    checkAvailData.length > 0 &&
                    checkAvailData.map((checkData, indexJax) => {
                      if (
                        checkData.expreience &&
                        checkData.expreience[0]["options"][0]["timing"] ==
                        "unavailable"
                      ) {
                        return (
                          reduxData != null &&
                          reduxData.length > 0 &&
                          Object.entries(reduxData).map((i, indexJ) => {
                            if (indexJax === indexJ) {
                              if (i[1].profileactivity != "Accommodations") {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].tourName}</td>
                                    <td>{i[1].traveller}</td>
                                    <td>{i[1].availability}</td>
                                  </tr>
                                );
                              } else {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].propertyName}</td>
                                    <td>
                                      {i[1].roombooking
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomBooking}</>;
                                        })}
                                    </td>
                                    <td>
                                      {i[1].cartvalue
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomAvail}</>;
                                        })}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          })
                        );
                      } else if (checkData.accomodation && (checkData.accomodation.toString() == "notavil")) {
                        return (
                          reduxData != null &&
                          reduxData.length > 0 &&
                          Object.entries(reduxData).map((i, indexJ) => {
                            if (indexJax === indexJ) {
                              if (i[1].profileactivity != "Accommodations") {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].tourName}</td>
                                    <td>{i[1].traveller}</td>
                                    <td>{i[1].availability}</td>
                                  </tr>
                                );
                              } else {
                                return (
                                  <tr>
                                    <th scope="row">{indexJ + 1}</th>
                                    <td>{i[1].propertyName}</td>
                                    <td>
                                      {i[1].roombooking
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomBooking}</>;
                                        })}
                                    </td>
                                    <td>
                                      {i[1].cartvalue
                                        .slice(-1)
                                        .map((item, index) => {
                                          return <>{item.roomAvail}</>;
                                        })}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          })
                        );
                      }
                    })}
                </tbody>
              </table>
            </div>
            <div>
              <div className="latoRegular font16 appendBottom15">
                We recommend you to try the following: <br></br>
                Try to search again and retry booking after waiting for 5-10
                mins.<br></br>
                If you're still unable to book, look for an alternative
                accommodation or experience
              </div>
              <div className="latoRegular font16 appendBottom15">
                <button onClick={closeModal} class="btn btn-danger float-left">
                  GO Back To Cart
                </button>
                <button
                  onClick={ContinuePayment}
                  class="btn btn-danger float-left"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
export default CartDropDown;
